<template>
  <action-menu-portal-container
    class="agent-action-resize-cache"
    data-testid="agent-action-resize-cache"
    :seperator="false"
    title="Resize Helper Cache"
    :disable="!submitEnabled"
    :loading="loading"
    @submit="submitAction"
  >
    <div style="padding: 12px">
      <incredi-input-num-with-menu
        :input-width="160"
        :placeholder="resizeCacheValuePlaceholder"
        default-option="MB"
        :value="resizeCacheValue"
        mask="######"
        menu-min-width="53"
        :filter="'disksize'"
        class="row hover-shadow"
        :menu-options="['MB']"
        id-name="agent-resize-cache"
        @input-change="
          (newVal, sizeType) => {
            let updatedNewVal = util.convertTimeToDays(newVal, sizeType);
            if (resizeCacheValue !== updatedNewVal) {
              inputUpdated = true;
            }
            resizeCacheValue = Number(updatedNewVal);
          }
        "
      />
    </div>
  </action-menu-portal-container>
</template>

<script>
import util from '@/views/settings/util';
import incrediInputNumWithMenu from '@/components/inputs/incrediInputNumWithMenu.vue';
import { useDialogPresets } from '@/services/dialogPresets.composable';
import { defineComponent } from 'vue';
import { useNotifyPresets } from './services/notifyPresets';
import ActionMenuPortalContainer from './agents-menu/components/action-menu-portal-container.vue';

export default defineComponent({
  name: 'AgentActionResizeCache',
  components: {
    incrediInputNumWithMenu,
    ActionMenuPortalContainer,
  },
  // mixins: [dialogPresets, notifyPresets],
  props: {
    agentsList: {
      type: Array,
      required: true,
    },
  },
  emits: ['submit'],
  setup() {
    const { dialogPresets } = useDialogPresets();
    const { notifyPresets } = useNotifyPresets();
    return { dialogPresets, notifyPresets };
  },
  data() {
    return {
      resizeCacheValuePlaceholder: null,
      resizeCacheValue: 1024,
      inputUpdated: false,
      // actionName: 'ResizeAgentCache',
      loading: false,
    };
  },
  computed: {
    util() {
      return util;
    },
    submitEnabled() {
      const isInteger = Number.isInteger(this.resizeCacheValue) && this.resizeCacheValue > 0;
      return this.isSingle ? isInteger : this.inputUpdated && isInteger;
    },
    isSingle() {
      return this.agentsList.length === 1;
    },
    // eslint-disable-next-line vue/no-unused-properties
    getResizeCacheData() {
      try {
        return typeof this.resizeCacheValue === 'string' ? parseInt(this.resizeCacheValue) : this.resizeCacheValue;
      } catch (e) {
        return 0;
      }
    },
  },
  mounted() {
    this.resizeCacheValue = this.isSingle ? this.agentsList[0].performance?.cacheSize : null;
    this.resizeCacheValuePlaceholder = this.resizeCacheValue;
  },
  methods: {
    async submitAction() {
      this.$emit('submit', this.resizeCacheValue);
    },
  },
});
</script>

<style lang="scss" scoped>
.agent-action-resize-cache {
  :deep(.ampc--footer-container) {
    padding-top: 0;
  }
  :deep(.ampc--body-container) {
    padding: 0;
  }
}
</style>
